export enum AddBankAccountsDialogConfig {
  NEW_FORM_NAME = 'new'
}
